module.exports = __webpack_public_path__ + "a740b71391e313667c02359f0a497367.ttf";